import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {
  transform(value, args: string[]): any {
    let keys = [];
    for (let i = 0; i < value.length; i++) {
      keys.push({ key: i, value: value[i] });
    }
    return keys;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/new-route/pipes/keys.pipe.ts